export const parseBase32 = (input: string): string => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
    let bits = '';
    let decoded = '';

    // Convert each Base32 character to a 5-bit binary string
    for (const char of input.replace(/=+$/, '')) {
        const index = alphabet.indexOf(char.toUpperCase());
        if (index === -1) continue;
        bits += index.toString(2).padStart(5, '0');
    }

    // Group the binary string into 8-bit chunks and convert to characters
    for (let i = 0; i + 8 <= bits.length; i += 8) {
        const byte = bits.slice(i, i + 8);
        decoded += String.fromCharCode(parseInt(byte, 2));
    }

    return decoded;
}
